var generic = generic || {};
var site = site || {};

site.direction = site.direction || {};

site.SkinFoundation = function (context) {
  this.init(context);
};

site.SkinFoundation.prototype = {
  $container: $(),
  $shadeSelect: $(),
  $shadeSelectCopy: $(),
  $shadeSelectBox: $(),
  $models: $(),
  $menus: $(),
  $btnMenu01: $(),
  $finishContainer: $(),
  $finish: $(),
  $modelTemplate: $(),
  $smooshTemplate: $(),
  $resultShade: $(),
  $btnFindShade: $(),
  $shadFinderContainer: $(),
  $productContainer: $(),
  productData: {},
  skuData: [], // starts as an array
  shadeNames: [],
  modelData: {},
  selectPreCopy: '',
  getProductData: function (data) {
    var self = this;

    if (_.isUndefined(typeof page_data['product-input-type']['products'])) {
      return false;
    } else {
      self.productData = page_data['product-input-type']['products'];
      $.each(self.productData, function (index, product) {
        self.skuData.push(product.skus);
      });
      self.skuData = _.flatten(self.skuData);
    }

    var tempProducts = {};

    $.each(self.productData, function (index, product) {
      var productID = product['PRODUCT_ID'];

      if (tempProducts.hasOwnProperty(productID)) {
        tempProducts[productID].push(product);
      } else {
        tempProducts[productID] = product;
      }
    });

    self.productData = tempProducts;

    self.getSkuData();
  },
  getSkuData: function () {
    var self = this;
    var tempSkus = {};

    $.each(self.skuData, function (index, sku) {
      var skuID = sku['SKU_ID'];

      tempSkus[skuID] = sku;
    });
    self.skuData = tempSkus;

    self.renderModels();
  },
  renderModels: function () {
    var self = this;

    self.modelData = {};
    $.each(self.skuData, function (index, sku) {
      var finishes = sku['FINISH'];

      if (_.isNull(finishes)) {
        return;
      }
      finishes = finishes.toString();
      finishes = finishes.split(',');
      var skuID = sku['SKU_ID'];
      var modelNumbers = sku['SHADE_NUMBER'];

      modelNumbers = modelNumbers.toString();
      modelNumbers = modelNumbers.split(',');

      // format data
      $.each(finishes, function (index, finish) {
        if (!self.modelData.hasOwnProperty(finish)) {
          self.modelData[finish] = {};
        }
        $.each(modelNumbers, function (index, modelNumber) {
          if (self.modelData[finish].hasOwnProperty(modelNumber)) {
            self.modelData[finish][modelNumber].push(skuID);
          } else {
            self.modelData[finish][modelNumber] = [skuID];
          }
        });
      });
    });

    $('.js-skin__foundation__slide__container').remove();
    $('.js-skin__foundation__model').remove();
    var finishContainerClass = 'skin__foundation__slide__container js-skin__foundation__slide__container';
    var $finishContainer = $('<div />', { 'class': finishContainerClass });
    var finishClass = 'skin__foundation__model js-skin__foundation__model';
    var $finish = $('<div />', { 'class': finishClass });

    // render slides
    $.each(self.modelData, function (key, value) {
      var key = key.toLowerCase();

      $.each(value, function (modelNumber, skus) {
        var templateData = {};
        // model_number
        // model_skus
        // model_shadenumber
        // model_shadename

        templateData['model_number'] = modelNumber;
        templateData['model_skus'] = skus;
        templateData['model_filter'] = key;

        var shade = self.skuData[skus[0]]['SHADENAME'];

        templateData['model_shadenumber'] = shade.replace(/([a-zA-Z()])/g, '').trim();
        templateData['model_shadename'] = shade.replace(/[0-9.()]/g, '').trim();

        var $model = Mustache.render(self.$modelTemplate, templateData);

        $finish.append($model);
      });

      $finishContainer.append($finish);
      self.$models.append($finishContainer);
    });

    var $modelImage = $finish.find('.js-skin-foundation-model');

    $modelImage.each(function () {
      var $datasrc = $(this).attr('data-src');

      $(this).attr('src', $datasrc);
    });
  },
  initSlide: function (finish) {
    var self = this;
    var $finishSliderContainer = $('.skin__foundation__slide__container');
    var $finishSlider = $('.skin__foundation__model');
    var bp = Unison.fetch.now();

    // PC
    if (!$finishSlider.hasClass('slick-initialized')) {
      $('.skin__foundation__model__id', $finishSlider).matchHeight();

      var bp = Unison.fetch.now();
      var $infinite = false;

      // mobile
      if (bp.name === 'small') {
        $infinite = false;
      }
      var settings = {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: $infinite,
        rtl: site.direction.isRTL,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 400,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

      $finishSlider.slick(settings);
      var $modelID = $('.skin__foundation__model__id', $finishSlider);

      $modelID.bind('click', function (event) {
        $modelID.removeClass('selected');
        $(this).addClass('selected');
        var skus = $(this).data('skus');

        self.renderResults(skus);
        if (bp.name === 'small') {
          var resultsBannerPos = self.$resultShade.offset().top - 54;

          $('html, body').animate({ scrollTop: resultsBannerPos }, {
            duration: 1333,
            easing: 'easeOutCubic'
          });
        }
      });

      $finishSlider.slickFilter('[data-filter="' + finish + '"]');
      $finishSlider.slickGoTo(0);
    } else {
      $finishSlider.slickFilter('[data-filter="' + finish + '"]');
      $finishSlider.slickGoTo(0);
    }

    $finishSliderContainer.addClass('active');
  },
  renderResults: function (result) {
    var self = this;
    var skus;

    if (typeof result === 'string') {
      if (result.indexOf(',') !== -1) {
        skus = result.replace(/\s+/g, '').split(',');
      } else {
        skus = [result];
      }
    } else {
      skus = result;
    }

    var ctaType = self.$shadFinderContainer.data('cta');
    var templateData = {};

    templateData['products'] = [];
    // smoosh_image1
    // smoosh_image2
    $.each(skus, function (index, skuID) {
      var sku = self.skuData[skuID];
      var productData = self.productData[self.skuData[skuID].PRODUCT_ID];

      if (self.$skinFoundationSkuCard.length > 0) {
        productData.sku_cards = 1;
        productData.sku_as_product = 1;
      }
      if (ctaType != null) {
        productData[ctaType] = 1;
      } else {
        productData.add_to_bag_link = 1;
      }
      productData.animate_cta = 1;
      productData.show_flag = 1;
      productData.defaultSku = self.skuData[skuID];
      productData.skus[0] = self.skuData[skuID];
      var bp = Unison.fetch.now();

      if (!(bp.name === 'small')) {
        templateData['is_carousel'] = 1;
      }
      templateData['products'].push(productData);
    });

    // result_shadename
    var shade = self.skuData[skus[0]]['SHADENAME'];

    templateData['result_shadename'] = shade.replace(/[0-9.()]/g, '').trim();

    var shadeNameNoNumbers = shade.replace(/[0-9.()]/g, '').trim();
    var shadeNameUrl = shadeNameNoNumbers.toString().split(' ').join('_');
    var shadeRouterPrefix = '\/#\/shade\/';

    // result_shade_description
    templateData['result_shade_description'] = self.skuData[skus[0]]['SHADE_DESCRIPTION'];

    // result_urls
    var tempProductUrls = [];

    $.each(self.productData, function (index, product) {
      var productUrls = product['url'];
      var productURL = $.makeArray(productUrls);

      tempProductUrls.push(productUrls);
    });

    // adding URL prefix and shadeName for SPP shade route
    templateData['result_url'] = tempProductUrls[0] + shadeRouterPrefix + shadeNameUrl;

    if (self.$productContainer.hasClass('hidden')) {
      $productContainer.removeClass('hidden');
    }

    if (!self.$resultShade.hasClass('open')) {
      self.$resultShade.slideDown('fast', function () {
        $('.skin__foundation__shade').addClass('active');
      }).addClass('open');
    } else {
      setTimeout(function () {
        $('.skin__foundation__shade').addClass('active');
      }, 100);
    }
    var args = {};

    args.name = 'product_grid_v1';
    args.data = templateData;
    var $result = site.template.get(args);

    self.$resultShadeCarousel.empty();
    self.$resultShadeCarousel.append($result);
    _equalHeight($('.product-thumb__headline', self.$resultShadeCarousel));
    _equalHeight($('.product__flag', self.$resultShadeCarousel));

    function _equalHeight($els) {
      if (!$els.length) {
        return;
      }
      $els.height('auto');
      var $tallest = $(_.max($els, function (el) {
        return $(el).height();
      }));

      if ($tallest.length) {
        $els.css('height', $tallest.height());
      }
    }
    var bp = Unison.fetch.now();

    // Initiate power review
    $(document).trigger('products.init-start');
    $('.js-skin__foundation__shade__carousel .js-product').trigger('product.init');
    $(document).trigger('products.init-finish');
    self.$resultShadeCarousel.find('.js-add-to-cart').addClass('product-thumb__cta');

    // mobile
    if (!(bp.name === 'small')) {
      site.productCarousel.init(self.$resultShade);
    }
    Drupal.behaviors.productGridProducts.attach(self.$resultShade);
  },
  initShadeSelect: function () {
    var self = this;
    var bp = Unison.fetch.now();

    // mobile menu
    isTouch = Modernizr.touch;

    if (isTouch) {
      site.util.refreshSelectBoxes(self.$shadeSelect);
    }

    self.$shadeSelect.selectBox({
      keepInViewport: true
    });

    var $selectBox = self.$shadeSelect.selectBox('control');

    self.$shadeSelect.prop('selectedIndex', -1);

    self.$shadeSelect.bind('change', function (event) {
      var val = $(this).val().trim();
      var skus = _.filter(self.skuData, function (sku) {
        return (typeof sku['SHADENAME'] === 'string' && sku['SHADENAME'].indexOf(val) !== -1) && (sku['SHADENAME'].indexOf(val) === 0);
      });

      skus = _.pluck(skus, 'SKU_ID');
      self.renderResults(skus);

      // remove default-blank class - first/default select option
      var thisOutterContainer = $(this).parent();

      thisOutterContainer.removeClass('default-blank').once();

      // grey out not in use drop down
      thisOutterContainer.removeClass('inactive');
      self.$btnFindShade.addClass('inactive');

      // closing finder elements in sequence
      self.$shadFinderContainer.slideUp('fast', function () {
        self.$finishContainer.slideUp('fast', function () {
          self.$models.removeClass('open').slideUp('fast', function () {
            // / animate to result banner // 54 to account for header/nav
            var resultsBannerPos = self.$resultShade.offset().top - 54;

            $('html, body').animate({ scrollTop: resultsBannerPos }, {
              duration: 1333,
              easing: 'easeOutCubic'
            });
          });
        });
      });
    });
  },
  getDom: function (context) {
    var self = this;

    self.$container = $(context);
    self.$shadeSelectCopy = $('.js-skin__foundation__dropdown__select__copy', self.$container).text();
    self.$shadeSelect = $('.js-skin__foundation__dropdown__select', self.$container);
    self.$menu = $('.js-skin__foundation__menu', self.$container);
    self.$btnMenu01 = $('.skin__foundation__menu--01', self.$container);
    self.$btnMenu02 = $('.skin__foundation__menu--02', self.$container);
    self.$btnMenu03 = $('.skin__foundation__menu--03', self.$container);
    self.$finishContainer = $('.js-skin__foundation__finishes', self.$container);
    self.$finish = $('.js-skin__foundation__finish', self.$container);
    self.$models = $('.js-skin__foundation__models__container', self.$container);
    self.$modelTemplate = $('.js-skin__foundation__model__id', self.$container).html();
    self.$smooshTemplate = $('.js-product-grid-carousel', self.$container).html();
    self.$resultShade = $('.js-skin__foundation__shade__container', self.$container);
    self.$resultShadeCarousel = $('.js-skin__foundation__shade__carousel', self.$resultShade);
    self.$btnFindShade = $('.js-skin__foundation__dropdown__button', self.$container);
    self.$shadFinderContainer = $('.js-skin__foundation__finder__container', self.$container);
    self.$productContainer = $('js-skin__foundation__product__header', self.$container);
    self.$skinFoundationSkuCard = $('.js-skin__foundation__sku__cards', self.$container);

    self.getProductData();
    self.setEvents();
  },
  toggleMenus: function (btn) {
    var self = this;

    self.$menu.removeClass('inactive active');
    var $parentMenu = $(btn).closest('.js-skin__foundation__menu').addClass('active');

    self.$menu.not($parentMenu).addClass('inactive');
  },
  setEvents: function () {
    var self = this;

    // removing menus / cms option
    if (!self.$btnMenu01.length) {
      self.$menu.remove();
    }

    self.initShadeSelect();

    self.$btnFindShade.bind('click', function (event) {
      event.preventDefault();
      // removing menus / cms option
      if (!self.$btnMenu01.length) {
        self.$shadFinderContainer.slideDown('fast', function () {
          self.$finishContainer.slideDown('fast');
        });
      } else {
        self.$shadFinderContainer.slideDown('fast');
        self.$menu.matchHeight();
      }
      // grey out not in use drop down
      $(this).removeClass('inactive');
      $('.skin__foundation__dropdown__select__container', self.$container).addClass('inactive');
    });

    // find my shade
    self.$btnMenu01.bind('click', function (event) {
      event.preventDefault();
      self.$finishContainer.slideDown('fast');
      self.toggleMenus(this);
    });

    self.$btnMenu02.bind('click', function (event) {
      self.toggleMenus(this);
    });

    self.$btnMenu03.bind('click', function (event) {
      self.toggleMenus(this);
    });

    self.$finish.bind('click', function (event, load) {
      event.preventDefault();
      self.$finish.removeClass('inactive');
      self.$finish.not($(this)).addClass('inactive');
      var finish = $(this).text().toLowerCase().trim();

      if (!self.$models.hasClass('open')) {
        self.$models.slideDown('fast').addClass('open');
      }
      self.initSlide(finish);
      var bp = Unison.fetch.now();

      if (load == null && bp.name === 'small') {
        if (self.$finishContainer.length > 0) {
          var $finishContainerTop = self.$finishContainer.offset().top - $('.site-header').height();

          window.scrollTo(0, $finishContainerTop);
        }
      }
    });
    self.$finish.first().trigger('click', 'load');
  },
  init: function (context) {
    var self = this;

    self.getDom(context);
    $(window).on('load', function () {
      self.$finish.first().trigger('click', 'load');
    });
    // Mobile orientation Models reload
    $(window).on('orientationchange', _.debounce(function (e) {
      var bp = Unison.fetch.now();

      if (bp.name === 'small') {
        self.renderModels();
        self.$finish.first().trigger('click');
      }
    }, 250));
  }
};

(function ($) {
  Drupal.behaviors.skinFoundationV2 = {
    attach: function (context) {
      var $container = $('.js-skin__foundation--v2', context);

      $container.each(function (index, el) {
        var skinFoundation = new site.SkinFoundation(this);
      });
    }
  };
})(jQuery);
